import { render, staticRenderFns } from "./SimilarAddressTable.vue?vue&type=template&id=00458653&scoped=true"
import script from "./SimilarAddressTable.vue?vue&type=script&lang=js"
export * from "./SimilarAddressTable.vue?vue&type=script&lang=js"
import style0 from "./SimilarAddressTable.vue?vue&type=style&index=0&id=00458653&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00458653",
  null
  
)

export default component.exports